import React, { Component, Fragment } from "react";
import Index from "../../Components/ProducaoEP/Realizado/Relatorio1/Index";
//import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Navbar from "../../Components/ProducaoEP/Realizado/UI/Navbar";
import NomeUnidade from "../../Components/UI/NomeUnidade";

export default class MenuRelatorioEP extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    componentDidMount() {
    }

    render() {
        let usuario = window.localStorage.user && JSON.parse(window.localStorage.user);
        let exibeUpload = usuario.roles.includes("ROLE_ADMIN");
        return (
            <Fragment>

                <div className="row">
                    <div className="col-md-12">

                        <div className="card text-center">
                            <div className="card-header pb-4">
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Produção Educação Profissional SENAI</h5>
                                <p className="card-text">Relatório da produção de Educação Profissional do SENAI</p>
                                <a href="/producaoep/relatorio1" className="btn btn-primary me-2">Realizado</a>
                                {/* <a href="/producaoep/relatorio4" className="btn btn-primary me-2">Metas</a> */}
                                <a href="/producaoep/relatorio3" className="btn btn-primary me-2">Metas/Realizado</a>
                                <a href="/producaoep/relatorio5" className="btn btn-primary me-2">Consolidado</a>
                                <a href="/producaoep/relatorio2" className="btn btn-primary me-2">Dinâmico</a>
                                {/* <a href="/producaoep/graficos" className="btn btn-primary me-2">Gráficos</a> */}
                                <a href="/producaoep/exports" className="btn btn-primary me-2">Exportações de Relatórios</a>
                                {
                                    exibeUpload ? <a href="/producaoep/upload" className="btn btn-primary me-2">Upload</a> : <span></span>
                                }
                                
                            </div>
                        </div>

                    </div>
                </div>

            </Fragment >
        )
    }
}